import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

const TrophyProgressIcon = (props) => (
  <Svg width={28} height={28} viewBox="0 0 28 28" fill="none">
    <Circle
      cx={14}
      cy={14}
      r={14}
      fill={props?.color ? props.color : "#6FB7D6"}
    />
    <Path
      d="M18.4999 8.7965V7.25H9.49988V8.7965H6.49988V11C6.49988 12.8938 7.91663 14.4485 9.74288 14.699C10.0045 15.4661 10.4684 16.1483 11.0857 16.6734C11.703 17.1986 12.4508 17.5472 13.2499 17.6825V18.5C13.2499 18.8978 13.0918 19.2794 12.8105 19.5607C12.5292 19.842 12.1477 20 11.7499 20H10.9999V21.5H16.9999V20H16.2499C15.8521 20 15.4705 19.842 15.1892 19.5607C14.9079 19.2794 14.7499 18.8978 14.7499 18.5V17.6825C15.549 17.5472 16.2967 17.1986 16.914 16.6734C17.5313 16.1483 17.9953 15.4661 18.2569 14.699C20.0831 14.4485 21.4999 12.8938 21.4999 11V8.7965H18.4999ZM7.99988 11V10.2965H9.49988V13.121C9.0615 12.9655 8.68197 12.6782 8.4134 12.2985C8.14483 11.9187 8.00038 11.4651 7.99988 11ZM19.9999 11C19.9993 11.4652 19.8548 11.9188 19.5863 12.2987C19.3177 12.6786 18.9383 12.9661 18.4999 13.1218V10.2965H19.9999V11Z"
      fill={props?.innerColor ? props.innerColor : "white"}
    />
  </Svg>
);

export default TrophyProgressIcon;
